import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  Input,
  Output,
  QueryList,
  EventEmitter,
  contentChild
} from "@angular/core";
import DevExpress from "devextreme";
import { mapDxToolbarItems } from "../page.support";
import { PageCardActionComponent } from "./page-card-action.component";
import { PageCardItemDescription } from "./page-card-item-description.component";
import { PageCardItemTitleDescription } from "./page-card-item-title-description.component";
import { PageCardItemComponent } from "./page-card-item.component";
import { PageCardSearchComponent } from "./page-card-search.component";
import { DragEndEvent, DragStartEvent } from "devextreme/ui/draggable";
import { PageToolbarComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar.component";

@Component({
  selector: "snoots-page-card",
  templateUrl: "page-card.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class PageCardComponent implements AfterContentInit {
  @ContentChildren(PageCardActionComponent)
  actions!: QueryList<PageCardActionComponent>;

  @ContentChild(PageCardSearchComponent)
  search: PageCardSearchComponent | null = null;

  @ContentChildren(PageCardItemComponent)
  items!: QueryList<PageCardItemComponent>;

  @ContentChild(PageCardItemTitleDescription)
  titleChild: PageCardItemTitleDescription | null = null;

  @ContentChild(PageCardItemDescription)
  description: PageCardItemDescription | null = null;

  toolbar = contentChild(PageToolbarComponent);

  @Input()
  title!: string;

  @Input()
  singleColumn!: boolean;

  @Input()
  noPadding!: boolean;

  @Input()
  dragEnabled: boolean = false;

  @Input()
  dragGroupName!: string;

  @Input()
  disableScroll: boolean = false;

  @Input()
  noDataText!: string;

  @Input()
  background: string | undefined;

  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  dxToolbarItems: DevExpress.ui.dxToolbarItem[] = [];

  ngAfterContentInit(): void {
    this.dxToolbarItems = buildToolbarItems(this.title, this.actions.toArray());
  }

  onSelect(): void {}

  onItemDragStart(cardElement: HTMLElement, dxEvent: DragStartEvent): void {
    dxEvent.itemData = dxEvent.fromData;
  }

  onItemDragEnd(dxEvent: DragEndEvent): void {
    if (dxEvent.toData) {
      dxEvent.cancel = true;
    }
  }
}

function buildToolbarItems(
  title: string,
  actions: PageCardActionComponent[]
): DevExpress.ui.dxToolbarItem[] {
  const items = mapDxToolbarItems({ actionItems: <any>actions });

  if (title) {
    items.push({
      text: title,
      location: "center"
    });
  }

  return items;
}
